module.exports = __webpack_public_path__ + "static/media/efficient-analysis.fa844b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/efficient-analysis.png
// module id = 1180
// module chunks = 0